// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_km-1";
export var quotedThread = "_km-0";